import React from 'react';

// Supermove
import {Space} from '@supermove/components';

// App
import Callout from '@shared/design/components/Callout';
import FieldInput from '@shared/design/components/Field/FieldInput';
import Text from '@shared/design/components/Text';
import {FormikSetupCallrailIntegrationFormType} from '@shared/modules/CallrailIntegration/forms/SetupCallrailIntegrationForm';

interface CallrailApiKeyFieldsProps {
  form: FormikSetupCallrailIntegrationFormType;
  field: string;
}

const CallrailApiKeyFields = ({form, field}: CallrailApiKeyFieldsProps) => {
  return (
    <React.Fragment>
      <Callout
        text={
          <React.Fragment>
            {'To obtain your API key, refer to the CallRail API documentation. '}
            <Text.Link
              onPress={() =>
                window.open(
                  'https://support.callrail.com/hc/en-us/articles/5711821845389-CallRail-s-API-documentation',
                  '_blank',
                  'noopener,noreferrer',
                )
              }
            >
              {'Instructions found here.'}
            </Text.Link>
          </React.Fragment>
        }
      />
      <Space height={16} />
      <FieldInput
        {...form}
        index={0}
        name={`${field}.callrailApiKey`}
        label={'CallRail API Key'}
        isRequired
        isResponsive
        input={{
          placeholder: 'Enter API key',
        }}
      />
    </React.Fragment>
  );
};

export default CallrailApiKeyFields;
